import { useState, useEffect } from 'react';
import type { InsightObjectAttribute } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute.tsx';
import type { ProjectPickerOption } from '@atlassian/jira-servicedesk-insight-projects-picker/src/common/types.tsx';
import { AttributeTypeMap } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute-types.tsx';
import type { CmdbObjectAttribute } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/attribute.tsx';

export const getProjectValuesFromCmdbObjectAttribute = (
	attribute?: CmdbObjectAttribute,
): ProjectPickerOption[] => {
	if (attribute && attribute.type === AttributeTypeMap.Project) {
		return attribute.objectAttributeValues.map(({ project: { id, name, avatarUrl, key } }) => ({
			id,
			name,
			avatarUrl,
			key,
		}));
	}
	return [];
};

export const getProjectValues = (attribute?: InsightObjectAttribute): ProjectPickerOption[] => {
	if (attribute && attribute.type === 'project') {
		return attribute.projectTypeValues.map(({ project: { id, name, avatarUrl, key } }) => ({
			id,
			name,
			avatarUrl,
			key,
		}));
	}
	return [];
};

export const useProjectValue = (attribute?: InsightObjectAttribute) => {
	const projects = getProjectValues(attribute);
	const [value, setValue] = useState<ProjectPickerOption[]>(projects);

	useEffect(() => {
		setValue(() => getProjectValues(attribute));
	}, [attribute]);

	return [value, setValue] as const;
};
